module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av444-e993b6f9def8e677c787face5ce643d0.jpg";